<div class="w-full max-w-[800px] px-4 sm:px-8 md:px-12 py-6 sm:py-8">

  <!-- Header -->
  <div class="flex items-center gap-3 mb-6">
    <div style="background: #dcfce7; border-radius: 12px; padding: 10px; display: flex; align-items: center; justify-content: center;">
      <mat-icon style="color: #1C593D; font-size: 24px; width: 24px; height: 24px;">payments</mat-icon>
    </div>
    <div>
      <h2 style="font-size: 1.25rem; font-weight: 700; color: #111827; margin: 0;">Marcar como pagada</h2>
      <p style="font-size: 0.8rem; color: #6b7280; margin: 0;">Confirmar envio de transferencia</p>
    </div>
  </div>

  <!-- Info de la transaccion -->
  <div style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 12px; padding: 16px; margin-bottom: 20px;">
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">

      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">ID Transaccion</span>
        <span style="color: #1e5a3f; font-weight: 700; font-size: 0.9rem; font-family: monospace;">
          #{{ transaction?.id }}
        </span>
      </div>

      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Beneficiario</span>
        <span style="color: #111827; font-weight: 600; font-size: 0.85rem;">
          {{ transaction?.cuentaBeneficiario?.nombre }} {{ transaction?.cuentaBeneficiario?.apellidos }}
        </span>
      </div>

      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Banco</span>
        <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">
          {{ transaction?.cuentaBeneficiario?.banco?.nombre }}
        </span>
      </div>

      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Cuenta</span>
        <span style="color: #2563eb; font-weight: 600; font-size: 0.85rem;">
          {{ transaction?.cuentaBeneficiario?.tipoCuenta?.nombre }} {{ transaction?.cuentaBeneficiario?.numeroCuenta }}
        </span>
      </div>

      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Monto</span>
        <span style="color: #1e5a3f; font-weight: 700; font-size: 1rem;">
          {{ transaction?.totalMonedaDestino | currency:'':'':'' }} {{ transaction?.monedaDestino }}
        </span>
      </div>

      <div *ngIf="transaction?.precio_compra">
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Precio Compra</span>
        <span style="color: #7c3aed; font-weight: 700; font-size: 0.9rem;">
          {{ transaction?.precio_compra | currency: '' }}
        </span>
      </div>

    </div>
  </div>

  <!-- Formulario -->
  <form [formGroup]="datosForm" class="w-full" *ngIf="datosForm">
    <div class="grid grid-cols-1 gap-4">
      <mat-form-field appearance="outline" class="w-full modern-field">
        <mat-label>Referencia</mat-label>
        <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">tag</mat-icon>
        <input type="text" matInput formControlName="referencia" placeholder="Opcional">
      </mat-form-field>

      <div>
        <label style="color: #374151; font-size: 0.85rem; font-weight: 600; display: block; margin-bottom: 8px;">
          Comprobante (opcional)
        </label>
        <div style="position: relative; border: 2px dashed #d1d5db; border-radius: 12px; padding: 16px; text-align: center; background: #fafafa; transition: border-color 0.2s;"
          [style.border-color]="datosForm.get('photo')!.value ? '#1C593D' : '#d1d5db'">

          <ng-container *ngIf="datosForm.get('photo')!.value">
            <div style="position: relative; display: inline-block;">
              <img [src]="datosForm.get('photo')!.value"
                style="max-height: 120px; max-width: 100%; border-radius: 8px; border: 1px solid #e5e7eb;" />
              <button (click)="fileInput.value = ''; datosForm.get('photo')?.setValue(null);"
                style="position: absolute; top: -8px; right: -8px; display: inline-flex; align-items: center; justify-content: center; width: 24px; height: 24px; background: #ef4444; color: white; border: none; border-radius: 6px; cursor: pointer;">
                <mat-icon style="font-size: 14px; width: 14px; height: 14px;">close</mat-icon>
              </button>
            </div>
          </ng-container>

          <div *ngIf="!datosForm.get('photo')!.value" style="display: flex; flex-direction: column; align-items: center; gap: 8px; padding: 8px 0;">
            <mat-icon style="color: #9ca3af; font-size: 32px; width: 32px; height: 32px;">cloud_upload</mat-icon>
            <span style="color: #6b7280; font-size: 0.8rem; font-weight: 500;">Arrastra una imagen o haz clic para adjuntar</span>
          </div>

          <input #fileInput type="file" multiple="false" accept="image/*" (change)="setFileData($event)"
            style="position: absolute; z-index: 9; opacity: 0; height: 100%; width: 100%; left: 0; top: 0; cursor: pointer;" />
        </div>
        <input matInput formControlName="photo" readonly [hidden]="true" />
      </div>
    </div>
  </form>

  <!-- Botones -->
  <div class="flex flex-col sm:flex-row justify-center gap-3 sm:gap-6 w-full mt-6">
    <button type="button" (click)="acceptTransaction()" [disabled]="datosForm?.invalid"
      class="w-full sm:w-1/2 text-center"
      style="display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
      [style.background-color]="datosForm?.valid ? '#1C593D' : '#d1d5db'"
      [style.color]="datosForm?.valid ? 'white' : '#9ca3af'"
      [style.cursor]="datosForm?.valid ? 'pointer' : 'not-allowed'"
      onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; vertical-align: middle; margin-right: 4px;">check_circle</mat-icon>
      Confirmar Pago
    </button>
    <button type="button" (click)="close()"
      class="w-full sm:w-1/2 text-center"
      style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
      onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
      Cancelar
    </button>
  </div>

</div>
